import React, { useState } from 'react'
import { Link, useHistory } from "react-router-dom";
import styles from '../styles/Navbar.module.css'
import { FiChevronDown } from "react-icons/fi";
import { HiMiniBars3BottomLeft } from "react-icons/hi2";
import { IoClose } from "react-icons/io5";
import { PiArrowCircleUpRightFill } from "react-icons/pi";
import navbarLogo from '../../../../assets/main-logo.png'
import Modal from '../../../../components/Modal/Modal';
import axios from 'axios';
import { API } from '../../../../config/API';
import Loader from '../../../../components/Loader/Loader';
import modalLogo from '../../../../assets/AppName.png';
import { Util } from '../../../../config/Util';

const Navbar = () => {

    const [showSidebar, setShowSidebar] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const history = useHistory();
    const [loginForm, setLoginForm] = useState({
        uniqueCode: '',
        userName: '',
        password: ''
    });
    const [loginLoading, setLoginLoading] = useState(false);
    const [loginError, setLoginError] = useState('');

    const toggleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const closeSidebar = () => {
        setShowSidebar(false);
    };

    // Function to open the modal
    const openModal = () => {
        setModalOpen(true);
        setShowSidebar(false);
    };

    // Function to close the modal
    const closeModal = () => {
        setModalOpen(false);
    };

    const handleLoginInput = (e) => {
        setLoginForm({ ...loginForm, [e.target.name]: e.target.value });
    };

    const redirectToDashboard = (loginResponse) => {
        console.log('Login Response:', loginResponse);
        const userRole = loginResponse.roles[0];

        if (userRole === 'SUPER_ADMIN') {
            history.push('/org-admin/overview');
        } else if (userRole === 'ADMIN') {
            history.push('/admin/home');
        } else if (userRole === 'EMPLOYEE') {
            history.push('/user/home');
        } else {
            console.error('Unknown user role:', userRole);
            setLoginError('Invalid user role.');
        }
    }

    const login = async () => {
        setLoginLoading(true);
        setLoginError('');
        //platform-admin
        if (loginForm.userName === 'platform-admin' && loginForm.password === 'platform-admin') {
            history.push('/platform-admin');
        }
        try {
            const response = await axios.post(API.login, loginForm);
            console.log(response.status, response.data);
            sessionStorage.setItem('userData', JSON.stringify(response.data))
            sessionStorage.setItem('tenantId', response.headers['x-tenant-id']);
            
            // // Check if ibtikar is enabled for this organization
            // if (Util.ibtikarEnabled.includes(loginForm.uniqueCode) || true) {
            //     sessionStorage.setItem('ibtikarEnabled', 'true');
            // } else {
            //     sessionStorage.setItem('ibtikarEnabled', 'false');
            // }
            
            if (response.status === 200 && response?.data?.status === 'S') {
                // handle successful login (e.g., redirect, store token, etc.)
                Util.loginStatus = true;
                Util.user = response.data.name;
                Util.userId = response.data.id;
                Util.saveToSession("auth", response.data);
                redirectToDashboard(response.data);
                setModalOpen(false);
            } else {
                setLoginError('Invalid credentials.');
            }
        } catch (error) {
            setLoginError('Login failed. Please try again.');
            console.log(error);
            
        }
        setLoginLoading(false);
    };

    return (
        <div>
            <Loader loading={loginLoading}></Loader>
            <section className={styles.navbar_container}>
                <div className={styles.navbar_overlay}></div>
                <div className={styles.navbar_wrapper}>
                    <div className={styles.navbar_logo}>
                        <button className={`${styles.hamburger_btn} ${showSidebar ? styles.active : ''}`} onClick={toggleSidebar} >
                            <HiMiniBars3BottomLeft />
                        </button>
                        <img src={navbarLogo} alt="" />
                    </div>

                    <div className={styles.navbar_option_container}>
                        <ul className={styles.navbar_options}>
                            <li>
                                <Link to="#" onClick={(e) => {
                                    e.preventDefault();
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }}>Home</Link>
                            </li>
                            <li>
                                <Link to="#faq-section" onClick={(e) => {
                                    e.preventDefault();
                                    const faq = document.getElementById('faq-section');
                                    if (faq) {
                                        faq.scrollIntoView({ behavior: 'smooth' });
                                    }
                                }}>FAQ</Link>
                            </li>
                            <li>
                                <Link to="#footer-section" onClick={(e) => {
                                    e.preventDefault();
                                    const footer = document.getElementById('footer-section');
                                    if (footer) {
                                        footer.scrollIntoView({ behavior: 'smooth' });
                                    }
                                }}>Contact</Link>
                            </li>
                        </ul>

                        <div className={styles.btn_section}>
                            <Link to='/signup'><button className={styles.signin_btn}>Sign Up</button></Link>

                            <button className={styles.signin_btn} onClick={openModal}>Sign In <span><PiArrowCircleUpRightFill /></span></button>
                        </div>
                    </div>

                </div>

                <Modal
                    isOpen={isModalOpen}
                    onClose={closeModal}
                >
                    <div className={styles.modal_img_wrapper}>
                        <img src={modalLogo} alt="" />
                    </div>
                    <div className={styles.login_form_container}>
                        <div className={styles.form_input_wrapper}>
                            <label htmlFor="">Company Code</label>
                            <input type="text" name="uniqueCode" value={loginForm.uniqueCode} onChange={handleLoginInput} />
                        </div>
                        <div className={styles.form_input_wrapper}>
                            <label htmlFor="">Username</label>
                            <input type="text" name="userName" value={loginForm.userName} onChange={handleLoginInput} />
                        </div>
                        <div className={styles.form_input_wrapper}>
                            <label htmlFor="">Password</label>
                            <input type="password" name="password" value={loginForm.password} onChange={handleLoginInput} />
                        </div>
                        <button onClick={login} disabled={loginLoading}>{loginLoading ? 'Signing In...' : 'Sign In'}</button>
                        {loginError && <div style={{ color: 'red', marginTop: 8 }}>{loginError}</div>}
                    </div>
                </Modal>

                <div className={`${styles.nav_sidebar} ${showSidebar ? styles.active : ''}`}>
                    <div className={styles.close_section}>
                        <span></span>
                        <button onClick={closeSidebar}><IoClose /></button>
                    </div>

                    <ul className={styles.sidebar_options}>
                        <Link>
                            <li>Home</li>
                        </Link>
                        <Link>
                            <li>Contact</li>
                        </Link>

                        <Link to='/signup'><button className={styles.sidebar_signup_btn}>Sign Up</button></Link>

                        <button className={styles.sidebar_login_btn} onClick={openModal}>Sign In <span><PiArrowCircleUpRightFill /></span></button>
                    </ul>
                </div>
            </section>
        </div>
    )
}

export default Navbar